<template>
  <card class="card-user">
    <p class="card-text"></p>
    <div class="author">
      <div class="block block-one"></div>
      <div class="block block-two"></div>
      <div class="block block-three"></div>
      <div class="block block-four"></div>
      <a href="javascript:void(0)">
        <img
          class="avatar"
          :src="user.photoURL ? user.photoURL : 'img/placeholder.jpg'"
          alt="..."
        />
      </a>
      <p class="description">{{ user.displayName }}</p>
    </div>
    <p></p>
    <div class="card-description text-center">
      Compte créé le {{ $moment(user.creationTime).format("ll") }}
    </div>

    <div class="card-description text-center">
      <span v-if="conf.isPro" class="badge-primary badge d-inline-block">
        Compte premium
      </span>
      <span v-if="!conf.isPro" class="badge-light badge d-inline-block">
        Compte basique
      </span>
    </div>

    <div class="card-description text-center">
      <span
        v-if="conf.isPro"
        @click="updateSubscription()"
        class="text-center text-primary btn btn-simple btn-sm"
      >
        Modifier mon abonnement
      </span>
    </div>

    <div slot="footer" class="button-container"></div>
  </card>
</template>
<script>
import { mapGetters } from "vuex";
import { openStripeDashboard } from "../../../dao/firestore";
export default {
  components: {},
  computed: {
    ...mapGetters({
      user: "auth/user",
      conf: "auth/conf"
    })
  },
  methods: {
    updateSubscription() {
      this.$swal(
        "C'est parti !",
        "Vous allez être redirigé vers notre partenaire de paiement Stripe",
        "success"
      );
      openStripeDashboard();
    }
  }
};
</script>
<style></style>
